module.exports = __webpack_public_path__ + "media/images/3-0-star-01-154c7f39b77f01a277ec167afb270648d990848f0093b17fcb6285466dd4b936.svg";